<template lang="pug">
div(
    :id="id",
    :class="{ 'cell-is-empty': isEmptyCell }"
)
    span.delete-cell.text-muted(
        v-if="!isEmptyCell && canManageOrderLayout",
        @click="removeCell"
    )
        i.material-icons close

    div(:style="style")
        .order-body(
            :class="{ 'cell-has-value': !isEmptyCell, 'cell-selected': isSelected }",
            @click="setSelectedCell",
        )
            .order-content
                div.cell-empty(v-if="isEmptyCell")
                    .dropdown(v-if="canManageOrderLayout")
                        i.material-icons.text-2x.pointer(
                            data-toggle="dropdown",
                            aria-haspopup="true",
                            aria-expanded="false"
                        ) add

                        .dropdown-menu
                            a.dropdown-item(@click="addProduct") Add Product
                            a.dropdown-item(@click="addVariant") Add Variant
                            a.dropdown-item(v-if="canManagePromotions" @click="addPromotion") Add Promotion
                            a.dropdown-item(@click="addGroup") Add Display Group
                        
                div(v-else)
                    //- product
                    div(v-if="actionType == 'product'")
                        span.clear.text-lg.text-shadow(v-show="cell.action.code !== null") {{ cell.action.code }}
                        span.text-shadow {{ cell.action.name }}
                    //- variant
                    div(v-if="actionType == 'variant'")
                        span.clear.text-lg(v-show="cell.action.product.code !== null") {{ cell.action.product.code }}
                        span {{ cell.action.product.name }}
                        span.block(:style="{ color: 'rgb(253, 178, 100)' }") {{ cell.action.name }}

                    div(v-if="actionType == 'group'")
                        button.view-group.btn.btn-sm.btn-icon.white.text-dark(@click="viewGroupPages", :style="{ position: 'absolute', right: '5px', top: '5px' }")
                            i.material-icons keyboard_arrow_right
                        span.clear.text-md.text-shadow {{ cell.action.name }}

                    div(v-if="actionType == 'promotion'")
                        span.clear.text-shadow {{ cell.action.name }}
                        small.text-shadow(:style="{ color: 'rgb(253, 178, 100)' }") {{ promotionType(cell.action) }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { OrderLayoutEvent } from './order-layout-bus';
import PermissionMixin from './order-layout-permission';
import PromotionPermissionMixin from '@js/franchise_component/promotion/mixin/promotion-permissions';
import PromotionTypes from '@js/store/promotion-types';

export default {
    mixins: [PermissionMixin, PromotionPermissionMixin],

    props: {
        x: {
            type: Number,
            required: true,
        },
        y: {
            type: Number,
            required: true,
        },
    },

    computed: {
        ...mapGetters('orderLayout', [
            'orderLayout',
            'getPageCellByGrid',
            'activePage',
            'hasSelectedGrid',
            'hasActivePage',
            'selectedGrid',
        ]),

        id() {
            return `${this.x},${this.y}`;
        },

        hasColor() {
            return !this.isEmptyCell && !_.isNull(this.cell.color);
        },

        style() {
            const style = { overflow: this.isEmptyCell ? 'visible' : '' };
            style['height'] = '100%';

            if (this.isEmptyCell) return style;
            if (this.actionType == 'group') style['position'] = 'relative';

            style['color'] = 'rgb(239, 235, 235)';
            if (!_.isNull(this.productImage)) {
                style[
                    'background-image'
                ] = `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url('${
                    this.productImage
                }')`;
                style['background-size'] = 'cover';
                style['background-repeat'] = 'no-repeat';
            } else {
                if (this.hasColor) {
                    style.background = this.cell.color;
                } else {
                    // default color
                    style.background = 'rgb(123, 123, 123)';
                }
            }

            return style;
        },

        productImage() {
            if (
                !this.isEmptyCell &&
                this.actionType == 'product' &&
                this.cell.action.media_urls.length
            ) {
                return this.cell.action.media_urls[0].s512;
            }

            if (
                !this.isEmptyCell &&
                this.actionType == 'variant' &&
                this.cell.action.product.media_urls.length
            ) {
                return this.cell.action.product.media_urls[0].s512;
            }

            return null;
        },

        cell() {
            return this.getPageCellByGrid(this.activePage.id, this.x, this.y);
        },

        grid() {
            return { x: this.x, y: this.y };
        },

        actionType() {
            return this.cell.action_type;
        },

        isEmptyCell() {
            return (
                _.isNull(this.cell) ||
                _.isNull(this.cell.action_type) ||
                _.isNull(this.cell.action)
            );
        },

        isSelected() {
            if (
                !this.hasActivePage ||
                this.isEmptyCell ||
                !this.hasSelectedGrid
            )
                return false;

            return (
                this.activePage.id == this.selectedGrid.page_id &&
                this.x == this.selectedGrid.x &&
                this.y == this.selectedGrid.y
            );
        },
    },

    methods: {
        ...mapActions('orderLayout', [
            'removePageCell',
            'viewGroup',
            'setSelectedGrid',
        ]),

        addProduct() {
            OrderLayoutEvent.$emit('add-product-cell', this.grid);
        },

        addVariant() {
            OrderLayoutEvent.$emit('add-variant-cell', this.grid);
        },

        addGroup() {
            OrderLayoutEvent.$emit('add-group-cell', this.grid);
        },

        addPromotion() {
            OrderLayoutEvent.$emit('add-promotion-cell', this.grid);
        },

        viewGroupPages() {
            this.viewGroup(this.cell.action.id);
            this.setSelectedGrid();
        },

        async setSelectedCell(e) {
            const elem = $(e.target);

            if (
                this.isEmptyCell ||
                elem.hasClass('view-group') ||
                elem.parent().hasClass('view-group')
            )
                return;

            const grid = await this.setSelectedGrid({
                page_id: this.activePage.id,
                x: this.x,
                y: this.y,
            });
        },

        promotionType(promotion) {
            let type = PromotionTypes.find(t => t.value === promotion.type);
            return type ? type.name : 'Unknown';
        },

        removeCell() {
            this.removePageCell({
                page_id: this.activePage.id,
                x: this.x,
                y: this.y,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.delete-cell {
    position: absolute;
    margin: -8px;
    font-size: 16px;
    background: #fff;
    opacity: 0.9;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    padding: 2px;
    cursor: pointer;
    z-index: 1;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-box.vue